import 'systemjs/dist/system';
import {_global} from './global-resolve';

_global._isSsr = false;
